import {CreateExtArgs, pointerUtils} from '@wix/document-manager-core'
import {MASTER_PAGE_ID, ACCESSIBILITY_SETTINGS_PATH} from './types'

const {getInnerPointer} = pointerUtils

export const extractLanguageCode = (language: string): string => {
    return language?.split('-')[0].toLowerCase()
}

const getAccessibilitySettingsPointer = (pointers: any) => {
    const masterPageDataPointer = pointers.data.getDataItemFromMaster(MASTER_PAGE_ID)
    return getInnerPointer(masterPageDataPointer, ACCESSIBILITY_SETTINGS_PATH)
}

export const getAccessibilitySettings = (createExtArgs: CreateExtArgs) => {
    const {dal, pointers} = createExtArgs
    return dal.get(getAccessibilitySettingsPointer(pointers)) || {}
}

export const setAccessibilitySettings = (createExtArgs: CreateExtArgs, settings: Record<string, any>) => {
    const {dal, pointers} = createExtArgs
    const pointer = getAccessibilitySettingsPointer(pointers)
    const currentSettings = dal.get(pointer) || {}
    dal.set(pointer, {...currentSettings, ...settings})
}
